export default {
  "home.heading.default": "tara, call tayo",
  "home.heading.loading": "Binubuksan yung room...",
  "home.heading.join": "ready ka na mag-join?",
  "home.heading.joined": "nakapasok ka na",
  "home.heading.pending": "waiting sa host",
  "home.body.default": "gawa ng room, send ang link, chill.",
  "home.body.loading": "wait lang, sinesetup lang yung room.",
  "home.body.join": "check mo cam at mic mo, tapos pasok na.",
  "home.body.joined": "live na yung room. share mo yung link o g na.",
  "home.body.joined_in_room": "nasa room na — pasok na o share mo yung link.",
  "home.body.pending": "naka-lock yung room. papapasukin ka rin ng host.",
  "home.cta.create": "Gumawa ng room",
  "home.cta.join": "Mag-join sa room",
  "home.cta.enter": "Pumasok sa room",
  "home.cta.creating": "Gumagawa...",
  "home.cta.joining": "Nagjo-join...",
  "home.cta.opening": "Binubuksan...",
  "home.cta.pending": "Waiting ma-approve...",
  "home.copy_link": "copy link",
  "home.copied": "copied na!",
  "home.leave": "leave room",
  "home.back": "back",
  "home.no_participants": "wala pang tao dito",
  "home.join_by_code": "join gamit ang invite code",
  "home.code_placeholder": "enter code",
  "home.name_placeholder": "pangalan mo",
  "home.people_one": "tao",
  "home.people_other": "katao",
  "home.marketing.invite.title": "Gumawa ng room,\nshare ang link.",
  "home.marketing.invite.body": "One tap lang para mag-start. Share mo yung link sa friends mo at pwede na sila mag-join — no downloads, no sign-ups.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Ikaw bahala\nsa look mo.",
  "home.marketing.look.body": "Color grading, softening, vignette — o i-blur mo buong mukha mo. Camera mo, look mo.",
  "home.marketing.host.title": "Space mo,\nrules mo.",
  "home.marketing.host.body": "I-lock ang room, i-mute ang iba, o i-kick sila. Ikaw ang host, ikaw ang masusunod.",
  "home.marketing.host.locked": "Naka-lock ang room",
  "home.marketing.host.waiting_to_join": "Waiting maka-join",
  "home.marketing.host.wants_to_join": "gustong mag-join",
  "home.marketing.anything.title": "Kahit para saan pa 'yan.",
  "home.marketing.anything.body": "Study sessions, game nights, work standups, watch party — o tambay lang.",
  "home.marketing.use_case.study_group": "📚 study group",
  "home.marketing.use_case.game_night": "🎮 game night",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ chikahan",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 book club",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "tapos na ang call",
  "ended.left": "nag-leave ka sa room.",
  "ended.room_ended": "tapos na ang {title} para sa'yo.",
  "ended.rejoin": "rejoin",
  "ended.rejoining": "nagre-rejoin...",
  "ended.home": "balik sa home",
  "call.connecting": "nagko-connect",
  "call.waiting": "waiting sa iba",
  "call.invite_code": "invite code",
  "call.audio_on": "naka-on ang audio",
  "call.muted": "naka-mute",
  "call.listening": "Nakikinig",
  "call.audio_muted": "Naka-mute ang audio",
  "call.speaking": "nagsasalita",
  "call.you": "ikaw",
  "call.you_label": "Ikaw",
  "call.you_suffix": "(ikaw)",
  "call.chat_placeholder": "mag-send ng message...",
  "call.guest": "guest",
  "call.room_fallback": "room",
  "call.focus_view": "Focus view",
  "call.grid_view": "Grid view",
  "call.swap_main_video": "Palitan ang main video",
  "call.open_chat": "I-open ang chat",
  "call.close_chat": "I-close ang chat",
  "call.leave_room": "Mag-leave sa room",
  "call.confirm_leave": "Mag-leave?",
  "call.mic_on": "Naka-on ang mic",
  "call.muted_label": "Naka-mute",
  "call.camera_off": "Naka-off ang camera",
  "call.connect_failed": "Connection failed — check mo internet mo tapos try ulit.",
  "call.camera_access_failed": "Hindi ma-access yung camera mo. Check mo browser permissions tapos try ulit.",
  "call.recording_failed": "Hindi mag-start yung recording. Tuloy pa rin ang call kahit wala 'to.",
  "call.initialize_failed": "May mali pag-start ng call. Pa-refresh na lang tapos try ulit.",
  "call.participants": "Participants",
  "call.open_participants": "I-open ang participants",
  "call.close_participants": "I-close ang participants",
  "call.lock_room": "I-lock ang room",
  "call.unlock_room": "I-unlock ang room",
  "call.locked": "naka-lock",
  "call.unlocked": "open",
  "call.kick_member": "I-kick sa room",
  "call.mute_member": "I-mute",
  "call.unmute_member": "I-unmute",
  "call.muted_by_host": "Muted ng host",
  "call.waiting_to_join": "Waiting maka-join",
  "call.approve": "Approve",
  "call.deny": "Deny",
  "call.profile_actions": "Profile actions",
  "call.profile_in_room": "Nasa room",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Ikaw",
  "call.profile_action_mute": "I-mute ang audio nila",
  "call.profile_action_mute_meta": "Para sa'yo lang — hindi nila malalaman",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "Mag-start ng private chat",
  "call.profile_action_view": "Tingnan ang full profile",
  "call.profile_action_view_meta": "Bio, languages, past sessions",
  "call.profile_action_report": "I-report",
  "call.profile_action_report_meta": "I-flag para ma-review",
  "call.profile_sheet_close": "I-close ang profile actions",
  "call.profile_open_actions": "I-open ang profile actions",
  "call.dm_title": "Direct message",
  "call.dm_back": "Back sa actions",
  "call.dm_close": "I-close ang direct message",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "Nasa room na 'to",
  "call.dm_private_label": "Private chat",
  "call.dm_private_meta": "Kayong dalawa lang makakakita ng messages na 'to",
  "call.dm_input_placeholder": "Mag-send ng private message…",
  "call.dm_send": "Send",
  "call.dm_just_now": "now",
  "call.dm_seen_just_now": "Seen just now",
  "call.dm_typing": "nagta-type si {name}…",
  "call.dm_minimize": "Minimize",
  "call.dm_active_indicator": "I-open ang convo",
  "call.dm_unread_messages": "{count} unread",
  "call.dm_toast_tap_to_open": "I-tap para i-open",
  "call.dm_reopen_aria": "I-open ulit ang convo kay {name}",
  "home.join_denied": "Hindi ka pinapasok ng host.",
  "home.error.room_not_found": "Wala namang ganyang room code.",
  "home.error.profile_required": "I-setup muna ang profile mo para makatuloy.",
  "home.cta.set_up_profile": "I-setup ang profile mo",
  "home.profile_trigger_new": "I-tap para mag-add ng details",
  "home.profile_trigger_new_aria": "I-setup ang profile mo",
  "home.profile_trigger_edit_aria": "I-edit ang profile mo",
  "profile.eyebrow_new": "say hi",
  "profile.eyebrow_edit": "profile mo",
  "profile.title_new": "I-customize mo.",
  "profile.title_edit": "I-edit ang profile",
  "profile.subtitle": "Kunting details lang para alam nila kung sino kausap nila.",
  "profile.add_photo": "Mag-add ng photo",
  "profile.add_photo_soon": "coming soon ang photos",
  "profile.photo_empty": "i-tap para mag-add ng photo",
  "profile.photo_ready": "ready na ang photo",
  "profile.photo_save_first": "i-save muna ang profile bago mag-upload ng photo",
  "profile.photo_crop_caption": "i-frame ang photo mo",
  "profile.photo_auto_caption": "drag at zoom, tapos automatic na mase-save",
  "profile.photo_upload": "Mag-upload ng photo",
  "profile.photo_replace": "Palitan ang photo",
  "profile.photo_remove": "I-remove ang photo",
  "profile.photo_cancel": "Cancel",
  "profile.photo_save": "I-save ang photo",
  "profile.photo_uploading": "Ina-upload ang photo…",
  "profile.photo_removing": "Nire-remove ang photo…",
  "profile.photo_choose_another": "Pumili ng iba",
  "profile.photo_drag_hint": "I-drag ang photo sa loob ng circle. Automatic mase-save ang changes.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Horizontal crop",
  "profile.photo_vertical": "Vertical crop",
  "profile.name_label": "Pangalan",
  "profile.name_placeholder": "Ano itatawag namin sa'yo?",
  "profile.gender_label": "Ako ay",
  "profile.gender.woman": "Babae",
  "profile.gender.man": "Lalaki",
  "profile.gender.unspecified": "Prefer not to say",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "optional",
  "profile.bio_placeholder": "Mga language na alam mo, mga trip mo, kahit ano…",
  "profile.cta_new": "G na",
  "profile.cta_edit": "I-save ang changes",
  "profile.saving": "Sini-save…",
  "profile.close": "I-close",
  "profile.error.save_failed": "Hindi ma-save ang profile mo. Try ulit.",
  "profile.error.avatar_invalid_type": "Pumili ng PNG, JPEG, GIF, o WebP na image.",
  "profile.error.avatar_too_large": "Pumili ng image na mas maliit sa 5 MB.",
  "profile.error.avatar_too_small": "Pumili ng image na at least 96 by 96 pixels.",
  "profile.error.avatar_load_failed": "Hindi ma-read yung image. Try ng ibang file.",
  "profile.error.avatar_failed": "Hindi ma-upload yung photo mo. Try ulit.",
  "profile.error.avatar_remove_failed": "Hindi ma-remove yung photo mo. Try ulit.",
  "effects.title": "Effects",
  "effects.soft": "Soft focus",
  "effects.vignette": "Vignette",
  "effects.face": "Face blur",
  "effects.face_preview_only": "Face blur (preview lang)",
  "effects.face_viewer_side": "Face blur (viewer-side)",
  "effects.face_strength": "Lakas ng face blur",
  "effects.grade.off": "OFF",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "WARM",
  "effects.grade.cool": "COOL",
  "effects.grade.bw": "B&W",
  "camera.off": "naka-off ang camera",
  "camera.check": "i-check ang camera mo",
  "camera.retry": "i-retry ang camera",
  "camera.ready": "ready na ang camera",
  "camera.idle.title": "I-on ang camera mo",
  "camera.idle.hint": "Hihingi kami ng access sa browser mo pag ready ka na.",
  "camera.idle.button": "I-on ang camera",
  "camera.status.idle": "Waiting sa'yo",
  "camera.status.off": "Naka-off ang camera",
  "camera.status.loading": "Naghahanap ng camera access...",
  "camera.status.denied": "I-allow ang camera access sa browser, tapos try ulit.",
  "camera.status.error": "Nag-fail ang camera preview. Try ulit.",
  "camera.status.unsupported": "Hindi pwede ang camera access sa browser na 'to.",
  "camera.status.insecure": "Kailangan ng HTTPS o localhost para sa camera access.",
  "camera.guest_name_placeholder": "Pangalan ng guest",
  "camera.flip": "I-switch ang camera",
  "camera.save_name": "I-save",
  "camera.edit_name": "I-edit ang pangalan",
  "mic.on": "I-off ang mic",
  "mic.off": "I-on ang mic",
  "video.on": "I-off ang camera",
  "video.off": "I-on ang camera",
  "chat.title": "chat",
  "chat.close": "I-close ang chat",
  "chat.loading": "naglo-load...",
  "chat.load_earlier": "i-load ang mga luma",
  "chat.empty": "wala pang messages",
  "chat.send_error": "Hindi na-send ang message — try ulit.",
  "chat.input_placeholder": "mag-type ng message...",
  "room.host": "Host",
  "app.room_default_title": "Gumawa ng room",
  "app.chat_connection_rejected": "Hindi maka-connect ang chat — try mo i-refresh.",
  "app.copy_failed": "Hindi ma-copy ang link. Try mo i-select at i-copy manually.",
  "app.chat_not_connected": "Hindi pa connected ang chat. Wait lang ng konti tapos try ulit.",
  "footer.terms": "Terms & Conditions",
  "footer.copyright": "© 2026 Yano.AI"
}
